import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';

const AttributesLoader = () => {
	return (
		<>
			<Skeleton
				variant="rounded"
				sx={(theme) => ({ height: theme.size.sm, width: theme.size.xXL })}
			/>
			<Skeleton
				variant="rounded"
				sx={(theme) => ({ height: theme.size.sm, width: theme.size.xXL })}
			/>
			<Skeleton
				variant="rounded"
				sx={(theme) => ({ height: theme.size.sm, width: theme.size.xXL })}
			/>
			<Skeleton
				variant="rounded"
				sx={(theme) => ({ height: theme.size.sm, width: theme.size.xXL })}
			/>
		</>
	);
};

export default AttributesLoader;
